import { useEffect, useState } from "react";

const StatusIndicator = ({
    color,
    msg,
}) => {
    const [isPulsing, setIsPulsing] = useState(false);
    const pulseEffect = color === "red" ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 255, 0, 1)';
    const staticEffect = color === "red" ? 'rgba(255, 0, 0, 0.3)' : 'rgba(0, 255, 0, 0.3)';

    useEffect(() => {
        const interval = setInterval(() => {
            setIsPulsing(prev => !prev);
        }, 500);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div
                style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: color,
                    marginRight: 10,
                    boxShadow: `0 0 15px ${isPulsing ? pulseEffect : staticEffect}`,
                    transition: 'box-shadow 0.5s ease-in-out',
                }}
            />
            {msg}
        </>
    )
}

export default StatusIndicator
